import type { IconData } from '@stacksjs/iconify-core'

export const gitlab: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10.006 18.443L6.326 7.118h7.36zm0 0L1.168 7.118h5.158zM1.168 7.118l8.838 11.325l-9.68-7.032a.76.76 0 0 1-.276-.852zm0 0L3.385.296a.38.38 0 0 1 .724 0l2.217 6.822zm8.838 11.325l3.68-11.325h5.157zm8.837-11.325l1.119 3.441a.76.76 0 0 1-.277.852l-9.68 7.032zm0 0h-5.157L15.902.296a.38.38 0 0 1 .725 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default gitlab
